export default {
  data: {
    args: {
      author: {
        type: 'Student',
        name: 'Test1 Student1',
        avatar: 'http://localhost:3000/assets/connect/default-avatar.png'
      },
      work: {
        type: 'Submission',
        title: 'Mix Media',
        subtitle: 'My Submission',
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        favouritable: {
          count: 0,
          favorited: false,
          path: null,
        },
        shareable: {
          title: 'Mix Media',
          description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
          share_url: 'http://www.kadenze.com',
          email_callback: (obj) => console.log('Implement email sharing with this info:', obj),
        },
        date: '2017-11-13T16:30:12.194-08:00'
      },
      navigation: {
        header: {
          title: 'Kadenze',
          logo: '/assets/svg/kadenze_logo_light.svg',
          url: '/'
        },
        referrer: {
          title: 'Back to Gallery',
          action: () => console.log('Pjax call back to somewhere')
        },
        browse_url: 'http://www.mocky.io/v2/5a0e14913000009e0d4334bc',
        next_url: 'http://www.mocky.io/v2/5a0ce5102e000072113a2cb6',
        prev_url: 'http://www.mocky.io/v2/5a0ce5532e00007d113a2cb7'
      },
      media: [
        {
          'id': 1105,
          'meta': {
            'type': 'code',
            'previewable': true,
            'downloadable': true,
            'h_lang': 'python'
          },
          'type': 'code',
          'file': {
            'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/999/coursework_field_entries/1105/Google_News.py',
            'h264_360_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/999/coursework_field_entries/1105/Google_News.py',
            'h264_720_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/999/coursework_field_entries/1105/Google_News.py',
            'gallery': {
              'url': null
            },
            'thumb': {
              'url': null
            },
            'video_thumb': {
              'url': null
            },
            'pdf_thumb': {
              'url': null
            },
            'audio_thumb': {
              'url': null
            }
          },
          'name': 'Google_News.py',
          'extension': '.py',
          'value': null,
          'comment_count': 2,
          'comments_path': null,
          'tracking_data': {},
          'slide_type': 'code-slide',
          'download_path': '/',
          'preview_path': ''
        }, {
          'id': 1106,
          'meta': {
            'type': 'other',
            'downloadable': true,
            'previewable': false
          },
          'type': 'other',
          'file': {
            'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1000/coursework_field_entries/1106/test.3dm',
            'h264_360_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1000/coursework_field_entries/1106/test.3dm',
            'h264_720_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1000/coursework_field_entries/1106/test.3dm',
            'gallery': {
              'url': null
            },
            'thumb': {
              'url': null
            },
            'video_thumb': {
              'url': null
            },
            'pdf_thumb': {
              'url': null
            },
            'audio_thumb': {
              'url': null
            }
          },
          'name': 'test.3dm',
          'extension': '.3dm',
          'value': null,
          'comment_count': 1,
          'comments_path': null,
          'tracking_data': {},
          'slide_type': 'other-slide',
          'download_path': '',
          'preview_path': ''
        }, {
          'id': 1107,
          'meta': {
            'type': 'text',
            'previewable': true,
            'downloadable': true
          },
          'type': 'text',
          'file': {
            'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1001/coursework_field_entries/1107/SampleCSVFile_2kb.csv',
            'h264_360_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1001/coursework_field_entries/1107/SampleCSVFile_2kb.csv',
            'h264_720_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1001/coursework_field_entries/1107/SampleCSVFile_2kb.csv',
            'gallery': {
              'url': null
            },
            'thumb': {
              'url': null
            },
            'video_thumb': {
              'url': null
            },
            'pdf_thumb': {
              'url': null
            },
            'audio_thumb': {
              'url': null
            }
          },
          'name': 'SampleCSVFile_2kb.csv',
          'extension': '.csv',
          'value': null,
          'comment_count': 0,
          'comments_path': null,
          'tracking_data': {},
          'slide_type': 'text-slide',
          'download_path': '',
          'preview_path': ''
        }, {
          'id': 1108,
          'meta': {
            'type': 'image',
            'previewable': true,
            'downloadable': true,
            'linkable': true
          },
          'type': 'image',
          'file': {
            'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1002/coursework_field_entries/1108/transparent.png',
            'h264_360_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1002/coursework_field_entries/1108/transparent.png',
            'h264_720_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1002/coursework_field_entries/1108/transparent.png',
            'gallery': {
              'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1002/coursework_field_entries/1108/gallery_transparent.png'
            },
            'thumb': {
              'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/22/coursework/589/coursework_field/1002/coursework_field_entries/1108/thumb_transparent.png'
            },
            'video_thumb': {
              'url': null
            },
            'pdf_thumb': {
              'url': null
            },
            'audio_thumb': {
              'url': null
            }
          },
          'name': 'transparent.png',
          'extension': '.png',
          'value': {
            'width': 316,
            'height': 405
          },
          'comment_count': 0,
          'comments_path': null,
          'tracking_data': {},
          'slide_type': 'image-slide',
          'download_path': '',
          'preview_path': ''
        },
        {
          'id': 1146,
          'meta': {
            'type': 'pdf',
            'previewable': true,
            'downloadable': true,
            'plagiarism_detectable': true
          },
          'type': 'pdf',
          'file': {
            'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1010/coursework_field_entries/1146/pdf-sample.pdf',
            'h264_360_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1010/coursework_field_entries/1146/pdf-sample.pdf',
            'h264_720_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1010/coursework_field_entries/1146/pdf-sample.pdf',
            'gallery': {
              'url': null
            },
            'thumb': {
              'url': null
            },
            'video_thumb': {
              'url': null
            },
            'pdf_thumb': {
              'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1010/coursework_field_entries/1146/pdf_thumb_pdf-sample.png'
            },
            'audio_thumb': {
              'url': null
            }
          },
          'name': 'pdf-sample.pdf',
          'extension': '.pdf',
          'value': null,
          'comment_count': 0,
          'comments_path': null,
          'tracking_data': {},
          'slide_type': 'previewable-slide',
          'download_path': '',
          'preview_path': '/courses/34/gallery/coursework/595/coursework_field_entries/1146/previwable'
        },
        {
          'id': 1144,
          'meta': {
            'type': 'audio',
            'streamable': true,
            'queueable': true,
            'downloadable': true
          },
          'type': 'audio',
          'file': {
            'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1008/coursework_field_entries/1144/sample.m4a',
            'h264_360_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1008/coursework_field_entries/1144/sample.m4a',
            'h264_720_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1008/coursework_field_entries/1144/sample.m4a',
            'gallery': {
              'url': null
            },
            'thumb': {
              'url': null
            },
            'video_thumb': {
              'url': null
            },
            'pdf_thumb': {
              'url': null
            },
            'audio_thumb': {
              'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1008/coursework_field_entries/1144/audio_thumb_sample.png'
            }
          },
          'name': 'sample.m4a',
          'extension': '.m4a',
          'value': null,
          'comment_count': 0,
          'comments_path': null,
          'tracking_data': {},
          'slide_type': 'audio-slide',
          'download_path': '',
          'preview_path': ''
        },
        {
          'id': 1145,
          'meta': {
            'type': 'video',
            'downloadable': true,
            'playable': true
          },
          'type': 'video',
          'file': {
            'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1009/coursework_field_entries/1145/DHwy-WkVYAA_vSF.mp4',
            'h264_360_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1009/coursework_field_entries/1145/DHwy-WkVYAA_vSF.mp4',
            'h264_720_url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1009/coursework_field_entries/1145/DHwy-WkVYAA_vSF.mp4',
            'gallery': {
              'url': null
            },
            'thumb': {
              'url': null
            },
            'video_thumb': {
              'url': 'https://s3.amazonaws.com/jesalgc.development/uploads/course/34/coursework/595/coursework_field/1009/coursework_field_entries/1145/video_thumb_DHwy-WkVYAA_vSF.jpg'
            },
            'pdf_thumb': {
              'url': null
            },
            'audio_thumb': {
              'url': null
            }
          },
          'name': 'DHwy-WkVYAA_vSF.mp4',
          'extension': '.mp4',
          'value': null,
          'comment_count': 0,
          'comments_path': null,
          'tracking_data': {},
          'slide_type': 'video-slide',
          'download_path': '',
          'preview_path': ''
        }
      ]
    }
  },
  methods: {

  },
  mounted() {

  },
};

